import React from 'react';
import classes from './Drawer.css';

const drawer = (props) => {

  const drawerClasses = [classes.Drawer];
  if (props.openState) {
    drawerClasses.push(classes.ShowDrawer);
  }

  return <div className={drawerClasses.join(' ')}></div>
}

export default drawer;


// WEBPACK FOOTER //
// ./src/components/Navigation/Drawer/Drawer.jsx